import { BoxxGenericState, getGenericInitialState } from '@boxx/core';
import {
  IStoreOrdersStateError,
  IStoreOrdersStateSuccess,
  OrderModel,
  StoreOrdersStateType,
} from '@boxx/store-core';
import { ActionReducer, createReducer, on } from '@ngrx/store';
import * as fromOrdersActions from './store-orders.actions';

export interface IStoreOrdersState
  extends BoxxGenericState<
    OrderModel[],
    IStoreOrdersStateSuccess,
    IStoreOrdersStateError
  > {
  selectedOrder: OrderModel;
}

export const ordersInitialState: IStoreOrdersState = {
  ...getGenericInitialState(),
  data: [],
  selectedOrder: null,
};

export const storeOrdersReducer: ActionReducer<IStoreOrdersState> =
  createReducer(
    ordersInitialState,
    on(
      fromOrdersActions.loadOrdersBeginAction,
      fromOrdersActions.loadOrderByIdBeginAction,
      fromOrdersActions.updateOrderBeginAction,
      (state): IStoreOrdersState => ({
        ...state,
        isLoading: true,
        error: null,
        success: null,
      })
    ),
    on(
      fromOrdersActions.loadOrdersSuccessAction,
      //fromOrdersActions.updateOrderSuccessAction,
      (state, action): IStoreOrdersState => ({
        ...state,
        isLoading: false,
        fetched: true,
        data: action.payload,
        error: null,
        success: { after: getStoreOrdersActionType(action.type) },
      })
    ),

    on(fromOrdersActions.updateOrderSuccessAction, (state, action) => Object.assign({}, state, {
      isLoading: false,
        fetched: true,
        error: null,
        success: { after: getStoreOrdersActionType(action.type), data: action.payload },
        data: state.data.map(order => {
        if (order.id === action.payload.id) {
          return {
            ...action.payload
          };
        }
        return order;
      })
    })),

    on(
      fromOrdersActions.loadOrderByIdSuccessAction,
      (state, action): IStoreOrdersState => ({
        ...state,
        isLoading: false,
        fetched: true,
        selectedOrder: action.payload,
        error: null,
        success: { after: getStoreOrdersActionType(action.type) },
      })
    ),
    on(
      fromOrdersActions.loadOrdersFailAction,
      fromOrdersActions.loadOrdersFailAction,
      fromOrdersActions.updateOrderFailAction,
      (state, action): IStoreOrdersState => ({
        ...state,
        isLoading: false,
        error: {
          after: getStoreOrdersActionType(action.type),
          error: action.errors,
        },
        success: null,
      })
    ),
    on(fromOrdersActions.clearOrdersSuccessErrorDataAction, (state) => ({
      ...state,
      error: null,
      success: null,
    }))
  );

const getStoreOrdersActionType = (
  type: fromOrdersActions.StoreOrdersActionTypes
) => {
  let action: StoreOrdersStateType;

  switch (type) {
    case fromOrdersActions.StoreOrdersActionTypes.loadOrdersSuccess:
    case fromOrdersActions.StoreOrdersActionTypes.loadOrdersFail:
      action = 'LOAD_ORDERS';
      break;
    case fromOrdersActions.StoreOrdersActionTypes.updateOrderSuccess:
    case fromOrdersActions.StoreOrdersActionTypes.updateOrderFail:
      action = 'UPDATE_ORDER';
      break;
    default:
      action = 'UNKNOWN';
  }

  return action;
};
